import { DAMAGE_AREAS, INCIDENT_TYPES, SEVERITIES, label } from "@/lib/insurance";
import { fmtDate } from "@/lib/api";

const Row = ({ k, v }) => (
  <div className="py-2 grid grid-cols-[150px_1fr] gap-3 text-sm"><dt className="text-[#56585E]">{k}</dt><dd className="text-[#0D141A] break-words">{v || "—"}</dd></div>
);

export const InsuranceSubmission = ({ r, photoUrl }) => {
  const v = r.vehicle || {};
  return (
    <div className="grid gap-5 lg:grid-cols-2" data-testid="insurance-submission">
      <dl className="rounded-2xl bg-white p-5 divide-y">
        <Row k="Insurer" v={r.company_name} />
        <Row k="Policy number" v={r.policy_number} />
        <Row k="Claim reference" v={r.claim_number} />
        <Row k="Insured" v={r.insured_name} />
        <Row k="Insured contact" v={r.insured_phone} />
        <Row k="Vehicle" v={[v.year, v.make, v.model, v.colour && `(${v.colour})`].filter(Boolean).join(" ")} />
        <Row k="Registration" v={v.registration} />
        <Row k="VIN" v={v.vin} />
        <Row k="Preferred assessment" v={r.preferred_from ? `${fmtDate(r.preferred_from)} – ${fmtDate(r.preferred_to || r.preferred_from)}` : null} />
      </dl>
      <dl className="rounded-2xl bg-white p-5 divide-y">
        <Row k="Incident" v={`${label(INCIDENT_TYPES, r.incident_type)}${r.incident_other ? ` – ${r.incident_other}` : ""}`} />
        <Row k="Date of incident" v={fmtDate(r.incident_date)} />
        <Row k="Severity" v={label(SEVERITIES, r.severity)} />
        <Row k="Drivable" v={r.drivable} />
        <Row k="Recovery required" v={r.recovery_required} />
        <Row k="Damage areas" v={(r.damage_areas || []).map((a) => label(DAMAGE_AREAS, a)).join(", ")} />
        <Row k="Damage description" v={<span className="whitespace-pre-line">{r.damage_description}</span>} />
        <Row k="Notes" v={r.notes && <span className="whitespace-pre-line">{r.notes}</span>} />
      </dl>
      <div className="lg:col-span-2 rounded-2xl bg-white p-5">
        <h3 className="font-display font-bold mb-3">Photos ({(r.photo_ids || []).length})</h3>
        <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-6 gap-3">
          {(r.photo_ids || []).map((id) => (
            <a key={id} href={photoUrl(id)} target="_blank" rel="noreferrer" data-testid={`insurance-photo-${id}`}>
              <img src={photoUrl(id)} alt="Damage" className="aspect-square w-full rounded-lg object-cover bg-[#F4F4F4]" />
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};
